module.exports = __webpack_public_path__ + "img/logo.d1a97ed0.png";